import FillBlanks from "../../components/ClassOne/EnvironmentScience/NeighbourhoodPlaces/FillBlanks";
import MultipleChoice from "../../components/ClassOne/EnvironmentScience/NeighbourhoodPlaces/MultipleChoice";
import TrueFalse from "../../components/ClassOne/EnvironmentScience/NeighbourhoodPlaces/TrueFalse";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/environmental-science/neighbourhood-place/fill-blanks", title: "Fill in the Blanks", component: FillBlanks },
    { url: "/class-one/environmental-science/neighbourhood-place/true-false", title: "True or False", component: TrueFalse },
    { url: "/class-one/environmental-science/neighbourhood-place/multiple-choice-question", title: "Multiple Choice Questions", component: MultipleChoice },
];

export default topics;